// extracted by mini-css-extract-plugin
export default {"container":"EnvSwitch_container__9MekY","switch":"EnvSwitch_switch__j6Ia-"};